// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenu-cls1_wAr","cls2":"AccountMenu-cls2_uCk AccountMenu-cls1_wAr"};